var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.addresses, function(address, index) {
        return _c("div", { key: index, staticClass: "row gutter-sm" }, [
          _c(
            "div",
            { class: [_vm.addressesNotEmpty ? "col-11" : "col-12"] },
            [
              _c("address-input", {
                attrs: {
                  value: _vm.addresses[index],
                  id: index,
                  expanded: _vm.addressesNotEmpty,
                  label: _vm.label,
                  hideLabel: _vm.hideLabel,
                  showIcon: _vm.showIcon,
                  "search-hint": _vm.searchHint
                },
                on: {
                  input: function($event) {
                    _vm.updateAddress($event, index)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addressesNotEmpty,
                  expression: "addressesNotEmpty"
                }
              ],
              staticClass: "col-1 text-right"
            },
            [
              _c("q-btn", {
                staticClass: "q-mt-lg",
                attrs: {
                  flat: "",
                  dense: "",
                  icon: "remove_circle",
                  color: "light"
                },
                on: {
                  click: function($event) {
                    _vm.clearAddress(index)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c("q-btn", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.addressesNotEmpty,
                expression: "addressesNotEmpty"
              }
            ],
            class: _vm.showControls ? "q-mr-xl" : "",
            attrs: { flat: "", dense: "", label: _vm.$t("additional_address") },
            on: { click: _vm.addAddress }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }